




import { Component, Vue, Watch } from 'vue-property-decorator';
import Manager from '@/layouts/Manager.vue';
import Website from '@/layouts/Website.vue';
import Proto from '@/layouts/Proto.vue';
import { Route } from 'vue-router';
import AuthService from '@/services/auth';
import User from '@/entities/User';

@Component({
    components: {
        Manager,
        Website,
        Proto,
    },
})
export default class App extends Vue {
    layout: string | null = null;

    authService = new AuthService();

    redirectIfNeeded(isLoggedIn: boolean, route: Route) {
        if (!isLoggedIn && (route.fullPath.startsWith('/user/'))) {
            this.$router.replace('/login');
        } else if (isLoggedIn && ['/login', '/register'].includes(this.$route.fullPath)) {
            this.$router.replace('/user/profile');
        }
    }

    @Watch('authService.isLoggedIn')
    handleLoggedInChange(isLoggedIn: boolean) {
        this.redirectIfNeeded(isLoggedIn, this.$route);
    }

    @Watch('$route', { immediate: true, deep: true })
    setLayout(route: Route) {
        if (this.$ga) {
            this.$ga.page(route.fullPath);
        }
        if (route.fullPath.startsWith('/manage')) {
            this.authService.getCurrentUser()
                .then((user: User) => {
                    if (user) {
                        if (user.role === 'admin') {
                            this.layout = 'manager';
                            return;
                        }

                        this.$router.replace('/');
                        return;
                    }

                    this.$router.replace('/login');
                })
                .catch(() => {
                    this.$router.replace('/login');
                });
        } else if (route.fullPath.startsWith('/design')) {
            this.layout = 'proto';
        } else {
            this.layout = 'website';
        }

        this.redirectIfNeeded(this.authService.isLoggedIn, route);
    }
}
